import { render, staticRenderFns } from "./ContratosLicencas.vue?vue&type=template&id=7698aab2"
import script from "./ContratosLicencas.vue?vue&type=script&lang=js"
export * from "./ContratosLicencas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports